import { MateriaHome } from '@shared/data-structure/interfaces';
import { ClientHome } from '@shared/data-structure/interfaces';

export const dataMaterias: MateriaHome[] = [
  {
    legalmattercode: 1,
    legalMatter: 'Derecho Administrativo',
    url: '/materia/administrativo-procedimiento-administrativo',
    color: '72FEF3',
  },
  {
    legalmattercode: 6,
    legalMatter: 'Derecho Comercial',
    url: '/materia/comercial',
    color: 'FFFF00',
  },
  {
    legalmattercode: 21,
    legalMatter: 'Derecho Penal',
    url: '/materia/penal-procesal-penal',
    color: '67FF03',
  },
  {
    legalmattercode: 5,
    legalMatter: 'Derecho Civil',
    url: '/materia/civil',
    color: 'D7FF87',
  },
  {
    legalmattercode: 28,
    legalMatter: 'Derecho del Trabajo',
    url: '/materia/trabajo-procedimiento-laboral',
    color: 'C6D09E',
  },
  {
    legalmattercode: 20,
    legalMatter: 'Derecho Notarial',
    url: '/materia/notarial',
    color: 'D4E6A6',
  },
  {
    legalmattercode: 15,
    legalMatter: 'Filosofía del Derecho',
    url: '/materia/filosofia',
    color: 'BCBDC0',
  },
  {
    legalmattercode: 12,
    legalMatter: 'Derechos Humanos',
    url: '/materia/derechos-humanos',
    color: 'F7931D',
  }
];


// LA INFORMACIÓN DE LOS CLIENTES ESTÁ DUPLICADA EN ASTREA VIRTUAL

export const dataClients: ClientHome[] = [
  {
    name: 'Banco Patagonia',
    url: 'https://www.bancopatagonia.com.ar',
    image: '/assets/images/clients/banco-patagonia.png',
  },
  {
    name: 'Banco Central',
    url: 'https://www.bcra.gob.ar',
    image: '/assets/images/clients/bcra.png',
  },
  {
    name: 'BiDi',
    url: 'https://www.bidi.la',
    image: '/assets/images/clients/bidi.png',
  },
  {
    name: 'Banco Nación',
    url: 'https://www.bna.com.ar',
    image: '/assets/images/clients/bna.png',
  },
  {
    name: 'Colegio de Abogados General Roca',
    url: 'https://www.aboroca.org.ar',
    image: '/assets/images/clients/cagr.png',
  },
  {
    name: 'Colegio de Abogados y Procuradores de Neuquén',
    url: 'https://abognqn.org',
    image: '/assets/images/clients/caypn.png',
  },
  {
    name: 'Consejo Magistratura CABA',
    url: 'https://consejo.jusbaires.gob.ar',
    image: '/assets/images/clients/cm-caba.png',
  },
  {
    name: 'Colegio de Escribanos de San Isidro',
    url: 'https://www.escribanossanisidro.com.ar',
    image: '/assets/images/clients/col-esc-san-isidro.png',
  },
  {
    name: 'Corte Suprema de Justicia de la Nación',
    url: 'https://www.csjn.gov.ar',
    image: '/assets/images/clients/csjn.png',
  },
  {
    name: 'El Dial',
    url: 'https://www.eldial.com',
    image: '/assets/images/clients/el-dial.png',
  },
  {
    name: 'Universidad Externado de Colombia',
    url: 'https://www.uexternado.edu.co',
    image: '/assets/images/clients/externado-colombia.png',
  },
  {
    name: 'Facultad de Derecho - UBA',
    url: 'http://www.derecho.uba.ar',
    image: '/assets/images/clients/fder-uba.png',
  },
  {
    name: 'IPESMI',
    url: 'https://ipesmi.edu.ar',
    image: '/assets/images/clients/ipesmi.png',
  },
  {
    name: 'Instituo Universitario de la Policia Federal Argentina',
    url: 'https://universidad-policial.edu.ar/',
    image: '/assets/images/clients/iupfa.png',
  },
  {
    name: 'Ediciones de la Lenga',
    url: 'https://www.delalenga.com.ar/',
    image: '/assets/images/clients/la-lenga.png',
  },
  {
    name: 'Magistraer',
    url: 'https://magistraer.com/',
    image: '/assets/images/clients/magistraer.png',
  },
  {
    name: 'Partido Judicial de Córdoba',
    url: 'https://www.justiciacordoba.gob.ar',
    image: '/assets/images/clients/pj-cordoba.png',
  },
  {
    name: 'Partido Judicial de Formosa',
    url: 'https://jusformosa.gob.ar',
    image: '/assets/images/clients/pj-formosa.png',
  },
  {
    name: 'Partido Judicial de La Pampa',
    url: 'https://justicia.lapampa.gob.ar',
    image: '/assets/images/clients/pj-la-pampa.png',
  },
  {
    name: 'Partido Judicial de Santa Cruz',
    url: 'https://www.jussantacruz.gob.ar',
    image: '/assets/images/clients/pj-santa-cruz.png',
  },
  {
    name: 'Universidad Siglo 21',
    url: 'https://21.edu.ar',
    image: '/assets/images/clients/siglo21.png',
  },
  {
    name: 'Tribunal Superior de Justicia CABA',
    url: 'https://www.tsjbaires.gov.ar',
    image: '/assets/images/clients/tsjbaires.png',
  },
  {
    name: 'Universidad Abierta Interamericana',
    url: 'https://uai.edu.ar/',
    image: '/assets/images/clients/uai.png',
  },
  {
    name: 'Universidad Católica de La Plata',
    url: 'https://www.ucalp.edu.ar',
    image: '/assets/images/clients/ucalp.png',
  },
  {
    name: 'Universidad Católica de Colombia',
    url: 'https://www.ucatolica.edu.co',
    image: '/assets/images/clients/ucatolica-col.png',
  },
  {
    name: 'Universidad Católica Boliviana',
    url: 'https://www.ucb.edu.bo',
    image: '/assets/images/clients/ucb.png',
  },
  {
    name: 'Universidad Católica de Cuyo',
    url: 'https://uccuyo.edu.ar',
    image: '/assets/images/clients/uccuyo.png',
  },
  {
    name: 'Universidad Católica de Santa María',
    url: 'https://ucsm.edu.pe',
    image: '/assets/images/clients/ucsm.png',
  },
  {
    name: 'Universidad del Aconcagua',
    url: 'https://www.uda.edu.ar',
    image: '/assets/images/clients/uda.png',
  },
  {
    name: 'Universidad de la Marina Mercante',
    url: 'https://www.udemm.edu.ar',
    image: '/assets/images/clients/udemm.png',
  },
  {
    name: 'Universidad del Museo Social Argentino',
    url: 'https://www.umsa.edu.ar',
    image: '/assets/images/clients/umsa.png',
  },
  {
    name: 'Universidad Notarial Argentina',
    url: 'https://www.universidadnotarial.edu.ar',
    image: '/assets/images/clients/una.png',
  },
  {
    name: 'Universidad Nacional del Centro de la Provincia de Bs. As.',
    url: 'https://www.unicen.edu.ar',
    image: '/assets/images/clients/unicen.png',
  },
  {
    name: 'Universidad Libre',
    url: 'https://www.unilibre.edu.co',
    image: '/assets/images/clients/universidad-libre.png',
  },
  {
    name: 'Universidad Nacional del Sur',
    url: 'https://www.uns.edu.ar',
    image: '/assets/images/clients/uns.png',
  },
  {
    name: 'Universidad Nacional de San Luis',
    url: 'https://www.unsl.edu.ar',
    image: '/assets/images/clients/unsl.png',
  },
  {
    name: 'Universidad Privada Antenor Orrego',
    url: 'https://upao.edu.pe',
    image: '/assets/images/clients/upao.png',
  },
  {
    name: 'Universidad Peruana de Ciencias Aplicadas',
    url: 'https://www.upc.edu.pe',
    image: '/assets/images/clients/upc.png',
  },
  {
    name: 'Universidad del Salvador',
    url: 'https://www.usal.edu.ar/ingreso',
    image: '/assets/images/clients/usal.png',
  },
]
